import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import InvestingInBetterFutureDetails from "./components/InvestingInBetterFutureDetails";

export default function InvestingInBetterFuture() {
  return (
    <Layout>
      <NewsHeader>Investing in a Better Future: SAJIDA’s Commitment to Building an Ecosystem for Change</NewsHeader>
      <InvestingInBetterFutureDetails />
    </Layout>
  );
}
